import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ClientesCard from './components/ClientesCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const ClientesMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Clientes'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <ClientesCard />
        </Col>
      </Row>
    </Container>;
};

export default ClientesMain;
